import { takeLinkParam, withLinkParam } from "@/utils/link-param"
import { decodeTabPanel, scopeTabRightSidebar, type TabPanel } from "./right-sidebar"

const panelsParam = "tab-panels"

/**
 * `href`, an app path, for a new tab whose right sidebar starts as `panel`, the
 * opening tab's. A tab opened any other way starts from the last panel chosen in any tab.
 */
export function tabPanelsLink(href: string, panel: TabPanel) {
  return withLinkParam(href, panelsParam, JSON.stringify(panel))
}

/**
 * Applies a `tabPanelsLink` to this tab's right sidebar and removes it from the
 * address. Call before the router reads the location. The shared layout
 * preference is unchanged, so tabs opened later still start from it.
 */
export function consumeTabPanelsLink() {
  const raw = takeLinkParam(panelsParam)
  if (!raw) return
  let value: unknown
  try {
    value = JSON.parse(raw)
  } catch {
    return
  }
  const panel = decodeTabPanel(value)
  if (panel) scopeTabRightSidebar(panel)
}
